import React, { useState } from "react";
import { FaAngleLeft, FaAngleRight, FaFileUpload } from "react-icons/fa";
import { MdClose } from "react-icons/md";
const VerifyInfo = ({
  setTabs,
  formData,
  setFormdate,
  register,
  handleSubmit,
  errors,
  onSubmit,
  watch,
  setValue,
}) => {
  const removeFile = (fieldName) => {
    setValue(fieldName, null);
  };

  const sellerType = watch("Seller_type");

  return (
    <div className="mt-4 max-w-md  ">
      {/* Document Upload Section */}
      <div className="p-0 sm:p-4 rounded-lg space-y-4">
        {/* Government ID */}
        <div className="space-y-2">
          <label className="block text-sm font-semibold">
            Government - Issued ID
          </label>
          <div className="flex items-center gap-3">
            <div className="flex items-center w-full border rounded-lg px-3 py-2 focus-within:ring-2 focus-within:ring-green-600">
              <input
                type="file"
                accept="application/pdf"
                id="governmentId"
                className="hidden"
                onChange={(e) => setValue("govt_id", e.target.files[0])}
              />
              <label
                htmlFor="governmentId"
                className="flex-grow cursor-pointer text-sm text-gray-500 truncate"
              >
                {watch("govt_id")
                  ? watch("govt_id").name
                  : "Upload Government-issued ID"}
              </label>
              <label htmlFor="governmentId" className="cursor-pointer">
                <FaFileUpload className="text-[25px]" />
              </label>
            </div>
            {watch("govt_id") && (
              <button
                type="button"
                onClick={() => removeFile("govt_id")}
                className="text-red-600 hover:text-red-800 text-lg"
                title="Remove file"
              >
                <MdClose />
              </button>
            )}
          </div>
          {errors.govt_id && (
            <p className="text-sm text-red-500">{errors.govt_id.message}</p>
          )}
          {/* <input type="hidden" {...register("govt_id")} /> */}
          <input
            type="hidden"
            // {...register("govt_id", { required: "Government ID is required" })}
          />
        </div>
        {/* Business Certificate */}
        {sellerType === "business" && (
          <div className="space-y-2">
            <label className="block text-sm font-semibold mb-1">
              Business Certificate{" "}
              <span className="text-xs text-gray-500 italic">
                (for Business Seller)
              </span>
            </label>
            <div className="flex items-center gap-3">
              <div className="flex items-center w-full border rounded-lg px-3 py-2 focus-within:ring-2 focus-within:ring-green-600">
                <input
                  type="file"
                  accept="application/pdf"
                  id="businessCertificate"
                  className="hidden"
                  onChange={(e) =>
                    setValue("business_certificate", e.target.files[0])
                  }
                />
                <label
                  htmlFor="businessCertificate"
                  className="flex-grow cursor-pointer text-sm text-gray-500 truncate"
                >
                  {watch("business_certificate")
                    ? watch("business_certificate").name
                    : "Upload Business Certificate"}
                </label>
                <label htmlFor="businessCertificate" className="cursor-pointer">
                  <FaFileUpload className="text-[25px]" />
                </label>
              </div>
              {watch("business_certificate") && (
                <button
                  type="button"
                  onClick={() => removeFile("business_certificate")}
                  className="text-red-600 hover:text-red-800 text-lg"
                  title="Remove file"
                >
                  <MdClose />
                </button>
              )}
            </div>
            {errors.business_certificate && (
              <p className="text-sm text-red-500">
                {errors.business_certificate.message}
              </p>
            )}

            {/* <input type="hidden" {...register("business_certificate")} /> */}

            <input
              type="hidden"
              // {...register("business_certificate", {
              //   required:
              //     sellerType === "business"
              //       ? "Business certificate is required"
              //       : false,
              // })}
            />
          </div>
        )}
      </div>

      {/* Bank Account Details Section */}
      <div className="mt-6 space-y-4 p-0 sm:px-4">
        <h2 className="text-lg font-semibold">Bank Account Details</h2>

        {/* Bank Name */}
        <div>
          <label className="block text-sm font-medium mb-1">Bank Name</label>
          <input
            type="text"
            {...register("bank_name", {
              required: "Bank name is required",
              maxLength: {
                value: 80,
                message: "Bank name cannot exceed 80 characters",
              },
            })}
            placeholder="Enter Your Bank Name"
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
          />
          {errors.bank_name && (
            <p className="text-sm text-red-500">{errors.bank_name.message}</p>
          )}
        </div>

        {/* Beneficiary Name */}
        <div>
          <label className="block text-sm font-medium mb-1">
            Beneficiary Name
          </label>
          <input
            type="text"
            {...register("account_holder_name", {
              required: "Beneficiary name is required",
            })}
            placeholder="Enter Your Beneficiary Name"
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
          />
          {errors.account_holder_name && (
            <p className="text-sm text-red-500">
              {errors.account_holder_name.message}
            </p>
          )}
        </div>

        {/* Account Number */}
        <div>
          <label className="block text-sm font-medium mb-1">
            Account Number
          </label>
          <input
            type="text"
            {...register("account_number", {
              required: "Account number is required",
            })}
            placeholder="Enter Your Account Number"
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
          />
          {errors.account_number && (
            <p className="text-sm text-red-500">
              {errors.account_number.message}
            </p>
          )}
        </div>

        {/* IFSC or SWIFT Code */}
        <div>
          <label className="block text-sm font-medium mb-1">
            IFSC or SWIFT Code
          </label>
          <input
            type="text"
            {...register("routing_number", {
              required: "IFSC or SWIFT code is required",
            })}
            placeholder="Enter Your IFSC or SWIFT Code"
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
          />
          {errors.routing_number && (
            <p className="text-sm text-red-500">
              {errors.routing_number.message}
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Account Holder Type
          </label>
          <select
            {...register("account_holder_type")}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
            defaultValue="individual"
          >
            <option value="">select holder type </option>
            <option value="individual">Individual</option>
            <option value="company">Company</option>
          </select>
        </div>

        {/* Passbook/Cancelled Cheque */}
        <div className="space-y-2">
          <label className="block text-sm font-medium mb-1">
            Passbook/Cancelled Cheque
          </label>
          <div className="flex items-center gap-3">
            <div className="flex items-center w-full border rounded-lg px-3 py-2 focus-within:ring-2 focus-within:ring-green-600">
              <input
                type="file"
                accept="image/*"
                id="passbookOrCancelledCheque"
                className="hidden"
                onChange={(e) =>
                  setValue("passbook_cancelled_cheque", e.target.files[0])
                }
              />
              <label
                htmlFor="passbookOrCancelledCheque"
                className="flex-grow cursor-pointer text-sm text-gray-500 truncate"
              >
                {watch("passbook_cancelled_cheque")
                  ? watch("passbook_cancelled_cheque").name
                  : "Upload Passbook/Cancelled Cheque"}
              </label>
              <label
                htmlFor="passbookOrCancelledCheque"
                className="cursor-pointer"
              >
                <FaFileUpload className="text-[25px]" />
              </label>
            </div>
            {watch("passbook_cancelled_cheque") && (
              <button
                type="button"
                onClick={() => removeFile("passbook_cancelled_cheque")}
                className="text-red-600 hover:text-red-800 text-lg"
                title="Remove file"
              >
                <MdClose />
              </button>
            )}
          </div>
          {errors.passbook_cancelled_cheque && (
            <p className="text-sm text-red-500">
              {errors.passbook_cancelled_cheque.message}
            </p>
          )}
          <input
            type="hidden"
            {...register("passbook_cancelled_cheque", {
              required: "passbook cancelled cheque  is required",
            })}
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="flex justify-between mt-6">
        <button
          type="button"
          onClick={() => setTabs(1)}
          className="px-3 flex items-center gap-10 py-2 rounded-full bg-green-800 text-white hover:bg-green-900"
        >
          <FaAngleLeft />
          Back
        </button>
        <button
          type="button"
          onClick={handleSubmit(() => setTabs(3))}
          className="px-3 flex items-center gap-10 py-2 rounded-full bg-green-800 text-white hover:bg-green-900"
        >
          Next
          <FaAngleRight />
        </button>
      </div>
    </div>
  );
};

export default VerifyInfo;
